import React from 'react';
import { ShowProps, User } from '../../types';
import UserDocumentsList from './UserDocumentsList';

const UserDocs: React.FC<ShowProps<User>> = ({
    record,
    basePath,
    permissions = [],
    ...props
}) => {
    if (!record) {
        return null;
    }

    return (
        <div>
            <UserDocumentsList
                record={{ id: Number(record.id) }}
                showAddButton={false}
            />
        </div>
    );
};

export default UserDocs;
